import { render, staticRenderFns } from "./BtnInserirUnidadeRegional.vue?vue&type=template&id=83fa7c96"
import script from "./BtnInserirUnidadeRegional.vue?vue&type=script&lang=js"
export * from "./BtnInserirUnidadeRegional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports